import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3839 20.3839C19.8957 20.872 19.1043 20.872 18.6161 20.3839L5.75 7.51777L5.75 15.75C5.75 16.4404 5.19036 17 4.5 17C3.80964 17 3.25 16.4404 3.25 15.75L3.25 4.5C3.25 3.80964 3.80964 3.25 4.5 3.25L15.75 3.25C16.4404 3.25 17 3.80964 17 4.5C17 5.19036 16.4404 5.75 15.75 5.75L7.51777 5.75L20.3839 18.6161C20.872 19.1043 20.872 19.8957 20.3839 20.3839Z"
        fill={colorValue}
      />
    </svg>
  );
};
